<router-outlet></router-outlet>
<pegasus-toasts-container></pegasus-toasts-container>

@if (progress().inProgress) {
  <div class="tw-fixed tw-inset-0 tw-bg-black tw-bg-opacity-50 tw-flex tw-justify-center tw-items-center "
       style="z-index: 9999">
    <div class=" tw-p-4 tw-rounded-lg tw-shadow-lg tw-w-[90%]">
      <ngb-progressbar class="tw-mb-3" style="height: 3rem;" type="danger" textType="dark" [value]="progress().progress"
                       [striped]="true" [animated]="true">
        <span class="tw-text-2xl tw-text-red-100 tw-font-semibold">{{ progress().message }}
          - {{ progress().progress + '%' }}</span>
      </ngb-progressbar>
    </div>
  </div>

}
@if (loading()) {
  <div class="tw-fixed tw-inset-0 tw-bg-black tw-bg-opacity-50 tw-flex tw-justify-center tw-items-center "
       style="z-index: 9999">
    <div class=" tw-p-4 tw-rounded-lg tw-w-[9%]">
      <div class="loader"></div>
    </div>
  </div>
}

